import React from 'react';
import {
  BaseMixin,
  ElementaryMixin,
  ContentMixin,
  ColorSchemaMixin,
  Tools,
  NestingLevelMixin
} from '../common/common.js';
import Environment from '../environment/environment.js'
//import {FloatMixin} from '../layout/layout.js';
import {Div} from './factory.js';
import Span from './span.js';
import Link from './link.js';
import Button from './button.js';

import './cookie-bar.less';

export const CookieBar = React.createClass({

  //@@viewOn:mixins
  mixins: [
    BaseMixin,
    ElementaryMixin,
    ContentMixin,
    ColorSchemaMixin,
    //FloatMixin,
    NestingLevelMixin
  ],
  //@@viewOff:mixins

  //@@viewOn:statics
  statics: {
    tagName: 'UU5.Bricks.CookieBar',
    nestingLevelList: Environment.getNestingLevelList('bigBoxCollection', 'box'),
    classNames: {
      main: 'uu5-bricks-cookie-bar uu5-common-bg',
      top: 'uu5-bricks-cookie-bar-top',
      bottom: 'uu5-bricks-cookie-bar-bottom',
      button: 'uu5-bricks-cookie-bar-button',
      link: 'uu5-bricks-cookie-bar-link'
    },
    defaults: {
      content: 'Cookies help us to provide, protect and improve our services. By viewing this site, you agree to their use.',
      expireDays: 10 * 365.25
    },
    opt: {
      nestingLevelRoot: true
    }
  },
  //@@viewOff:statics

  //@@viewOn:propTypes
  propTypes: {
    agreedText: React.PropTypes.any,
    infoText: React.PropTypes.any,
    infoHref: React.PropTypes.string,
    infoTarget: React.PropTypes.oneOf(['_blank', '_parent', '_top', '_self']),
    fixed: React.PropTypes.oneOf(['top', 'bottom']),
    onAgree: React.PropTypes.func,
    expireDays: React.PropTypes.number,
    cookieKey: React.PropTypes.string,
    cookieValue: React.PropTypes.string
  },
  //@@viewOff:propTypes

  //@@viewOn:getDefaultProps
  getDefaultProps: function () {
    return {
      agreedText: 'I Understand',
      infoText: null,
      infoHref: null,
      infoTarget: '_blank',
      fixed: 'bottom',
      onAgree: null,
      expireDays: null,
      cookieKey: 'uu5-cookies',
      cookieValue: 'yes'
    };
  },
  //@@viewOff:getDefaultProps

  //@@viewOn:standardComponentLifeCycle
  componentWillMount: function () {
    this.props.expireDays ? this._checkCookies() : this._checkLocalStorageItem();
  },

  componentWillReceiveProps: function (nextProps) {
    this.props.expireDays ? this._checkCookies() : this._checkLocalStorageItem();
  },
  //@@viewOff:standardComponentLifeCycle

  // Interface

  // Overriding Functions

  //@@viewOn:interface
  //@@viewOff:interface

  //@@viewOn:overridingMethods
  //@@viewOff:overridingMethods

  //@@viewOn:componentSpecificHelpers
  _checkCookies: function () {
    if (Tools.getCookie(this.props.cookieKey) === this.props.cookieValue && !this._isAgreed) {
      this._isAgreed = true;
      this.setState({hidden: true}, this.props.onAgree);
    }
    return this;
  },

  _checkLocalStorageItem: function () {
    var item = localStorage.getItem(this.props.cookieKey);
    if (item === this.props.cookieValue) {
      this.setState({hidden: true}, this.props.onAgree);
    }
    return this;
  },

  _setLocalStorageItem: function () {
    localStorage.setItem((this.props.cookieKey), this.props.cookieValue);
    this.hide(this.props.onAgree);
  },

  _confirm: function () {
    Tools.setCookie(this.props.cookieKey, this.props.cookieValue, this.props.expireDays || this.getDefault().expireDays);
    this.hide(this.props.onAgree);
  },

  _getText: function () {
    var content = this.getContent();

    if (!content && !this.props.children) {
      content = this.getDefault().content;
    }

    return <Span content={content}>{this.props.children && React.Children.toArray(this.props.children)}</Span>;
  },

  _getButton: function () {
    var buttonProps = {
      content: this.props.agreedText,
      onClick: this.props.expireDays ? this._confirm : this._setLocalStorageItem,
      className: this.getClassName().button
    };

    return <Button {...buttonProps} />;
  },

  _getLink: function () {
    var link = null;

    if (this.props.infoText) {
      // href -> linkHref || undefined -> if undefined, default prop of link is set - other way, null is set
      link = <Link
        content={this.props.infoText}
        href={this.props.infoHref || undefined}
        className={this.getClassName().link}
        target={this.props.infoTarget}
      />;
    }

    return link;
  },

  _getMainProps: function () {
    var mainProps = this.getMainPropsToPass(['UU5_Common_BaseMixin', 'UU5_Common_ElementaryMixin']);
    this.props.fixed && (mainProps.className += ' ' + this.getClassName(this.props.fixed));

    mainProps.nestingLevel = this.getNestingLevel();

    return mainProps;
  },
  //@@viewOff:componentSpecificHelpers

  //@@viewOn:render
  render: function () {
    return (
      <Div {...this._getMainProps()}>
        {this._getText()}
        {this._getButton()}
        {this._getLink()}
      </Div>
    );
  }
  //@@viewOff:render
});

export default CookieBar;



// WEBPACK FOOTER //
// ./bricks/cookie-bar.js